import React from "react";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { Link } from "../../components/Link";
import { IFormHelpLink } from "../../models/formFields";
import { FormFieldWrapper } from "../FormFieldWrapper";
import { FORM_HELP_TEXT_CLASS_NAME } from "../classNames";
import { getDescribedByElemID } from "../hooks/formUtils";

export const FormHelpLink = (props: IFormHelpLink): React.ReactNode => {
    const helpTextClasses = concatClassNames([
        FORM_HELP_TEXT_CLASS_NAME,
        props.helpTextClass,
    ]);

    return (
        <FormFieldWrapper {...props}>
            <p
                className={helpTextClasses}
                id={props.id ? getDescribedByElemID(props.id) : undefined}
            >
                <Link href={props.href} target={props.target || "_top"}>
                    {props.helpText}
                </Link>
            </p>
        </FormFieldWrapper>
    );
};
